export default class ApiBaseModel {
    globalId: string = "";
    isVisible: boolean = true;
    isDirty: boolean = false;
}